export function clamp(
  val: number,
  { min, max }: { min: number; max: number }
): number {
  return Math.min(max, Math.max(min, val));
}
